import React, { memo } from "react";
import { Filter, DebouncedInput } from "../util/customInputs";

const TableFilters = memo(
  ({ globalFilter, setGlobalFilter, headerGroups, needGlobalFilter }) => {
    return (
      <>
        {headerGroups.map((headerGroup) => (
          <div
            key={headerGroup.id}
            className="flex flex-col sm:flex-row flex-wrap gap-4 p-4 bg-slate-200 dark:bg-gray-900/80 shadow-lg rounded-xl border border-gray-200 dark:border-gray-700"
          >
            {needGlobalFilter && (
              <DebouncedInput
                value={globalFilter || ""}
                onChange={(value) => setGlobalFilter(String(value))}
                placeholder="Search Name, Username..."
                // className="flex-1 min-w-[250px] sm:w-80 p-2 text-gray-700 dark:text-gray-300
                //        bg-gray-100 dark:bg-gray-700 border border-gray-300
                //        dark:border-gray-600 rounded-lg focus:ring-2
                //        focus:ring-blue-300 dark:focus:ring-blue-500"
              />
            )}
            {headerGroup.headers.map((header) =>
              header.column.getCanFilter() ? (
                <Filter key={header.id} column={header.column} />
              ) : null
            )}
          </div>
        ))}
      </>
    );
  }
);

export default TableFilters;
